import Vue from 'vue'
// import axios from 'axios'
import App from './App.vue'
import VueFullPage from 'vue-fullpage.js'
import {VueReCaptcha} from 'vue-recaptcha-v3'
import VueCookies from 'vue-cookies'
import store from './store'

Vue.use(VueCookies)
Vue.config.productionTip = false
Vue.use(VueFullPage)
Vue.use(VueReCaptcha, {siteKey: '6LcHFqAUAAAAAEO714JMhVwyUmNsMBskF5WfvfVv', loaderOptions: {
  autoHideBadge:true
} })

new Vue({
  store,
  render: h => h(App),
  beforeCreate() {
    // const params = new URLSearchParams(window.location.search)
    // if(params.get('step') && params.get('stepId')){
    //   store.commit('showLoader')
    //   axios.post(`${store.state.backendUrl}/completeUserStep`, {
    //     step: params.get('step'), 
    //     stepId: params.get('stepId'),
    //     goldCompleted: params.get('goldCompleted') === 'true'
    //   }).then(resp => {
    //     store.commit('setCreated', resp.data.created)
    //     store.commit('setSteps', resp.data.steps)
    //     store.commit('setWentForItStatus', params.get('goldCompleted') === 'true'? 'gold':'normal' )
    //     store.commit('goToWinEmailEntry')
    //     this.$cookies.set('user', resp.data, -1)
    //   }).catch((err) => {
    //     console.log(err)
    //   }).finally(() => {
    //     store.commit('hideLoader')
    //   })
    // } else if( this.$cookies.get('user')) {
    //   store.commit('setSteps', this.$cookies.get('user').steps)
    //   store.commit('setCreated', this.$cookies.get('user').created)
    //   store.commit('goToWinEmailEntry')
    // }

    // if(!this.$cookies.get('couponUrl')){
    //   axios.get(`${store.state.backendUrl}/getCouponUrl`).then(resp => {
    //     this.$cookies.set('couponUrl', resp.data.couponUrl)
    //     store.commit('setCouponUrl', resp.data.couponUrl)
    //   })
    // }
    // else {
    //   store.commit('setCouponUrl', this.$cookies.get('couponUrl'))
    // }
  },
  mounted() {
    if(window.location.hash.indexOf('rules') > -1){
      store.commit('openModal', 'rules')
    }
  },
}).$mount('#app')

